import ButtonT from '@components/tailwind-components/Button/ButtonT';
import InputWithLabelT from '@components/tailwind-components/Input/InputWithLabelT';
import { useBlocksUpdates } from '@hooks/flow/block/useBlocksUpdates';
import { useFlow } from '@hooks/flow/flow/useFlow';
import { useModal } from '@hooks/modal/useModal';
import type React from 'react';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type TRefParam = {
  refParam: string;
};

export const EditRefParamDestinationModal: React.FC = () => {
  const { selectedBlock, targetBlock } = useFlow();
  const { updateBlocks } = useBlocksUpdates();
  const { t } = useTranslation();

  const { hideModal } = useModal();

  const { handleSubmit, control } = useForm({
    shouldUseNativeValidation: true,
    defaultValues: { refParam: '' },
  });

  const onSubmit = useCallback(
    (data: TRefParam) => {
      if (
        !selectedBlock ||
        !targetBlock?.id ||
        selectedBlock.type !== 'Decider'
      ) {
        return;
      }

      const updatedBlock = {
        ...selectedBlock,
        params: {
          ...selectedBlock.params,
          possibleDestinations: [
            ...selectedBlock.params.possibleDestinations,
            {
              blockId: targetBlock.id,
              rules: [
                {
                  operand: data.refParam,
                  operator: 'eq' as const,
                },
              ],
            },
          ],
        },
      };

      updateBlocks([updatedBlock]);
      return hideModal();
    },
    [hideModal, selectedBlock, targetBlock?.id, updateBlocks],
  );

  return (
    <form className='tailwind-modal-form' onSubmit={handleSubmit(onSubmit)}>
      <div className='tailwind-modal-body'>
        <p className='text-sm mb-2 italic'>
          {t('flow.form.description.ref-param')}
        </p>
        <div className='grid grid-cols-1 gap-x-6 gap-y-2'>
          <div className='col-span-1'>
            <InputWithLabelT
              type='text'
              field='refParam'
              placeholder={t('flow.form.description.field')}
              label={t('flow.form.description.field')}
              id='refParam'
              control={control}
            />
          </div>
        </div>
      </div>
      <div className='tailwind-modal-footer'>
        <ButtonT type='submit' styling='primary' size='xs' rounding='md'>
          {t('general.buttons.save')}
        </ButtonT>
      </div>
    </form>
  );
};
